import i18n from '@/lang/i18n'

export default [{
  path: '/admin/institution/BigDataScreen',
  name: 'InstitutionBigDataScreen',
  component: () => import('@/views/institution/device/bigDataScreen'),
  meta: {
    title: i18n.t('router.device.data_screen'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/deviceList',
  name: 'InstitutionDeviceList',
  component: () => import('@/views/institution/device/deviceList'),
  meta: {
    title: i18n.t('router.device.device_list'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/deviceAlarm',
  name: 'InstitutionDeviceAlarm',
  component: () => import('@/views/institution/device/deviceAlarm'),
  meta: {
    title: i18n.t('router.device.alarm_record'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/screenConfig',
  name: 'InstitutionScreenConfig',
  component: () => import('@/views/institution/device/screenConfig'),
  meta: {
    title: i18n.t('router.device.screen_setting'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}]



// WEBPACK FOOTER //
// ./src/router/institution/device.js